/**
 * Datos mock para las 10 nuevas gráficas de estadísticas.
 * Se usan como fallback cuando los endpoints del backend aún no existen.
 */

// G1: Personas desaparecidas por año de desaparición y sexo
/*
  Título: Personas desaparecidas, por año de desaparición y sexo (2019-<año de la fecha de corte>)
  Subtítulo: Datos al <fecha de corte>
  Gráfica: Gráfica de barras horizontales apiladas. El dato a graficar es personas por año de
  desaparición, agrupadas por sexo (sólo mujeres y hombres), de 2019 a 2026.
  2019 debe ser el primer año que se muestre (parte superior).
  Nota a pie de gráfica: Se consideran sólo las desapariciones ocurridas a partir de 2019.
*/
export const mockMissingByYearData = [
  { label: '2019', values: [155, 1547] },
  { label: '2020', values: [182, 1262] },
  { label: '2021', values: [222, 1250] },
  { label: '2022', values: [190, 1387] },
  { label: '2023', values: [163, 1290] },
  { label: '2024', values: [133, 1019] },
  { label: '2025', values: [163, 838] },
];

// G2: Personas desaparecidas periodo comparable y sexo
/*
  Título: Personas desaparecidas del 1 de enero al <día y mes de la fecha de corte> de 2019 a
  <año de la fecha de corte>
  Subtítulo: Datos al <fecha de corte>
  Gráfica: Gráfica de barras horizontales apiladas. El dato a graficar es personas reportadas y
  desaparecidas en el periodo del 1 de enero a la fecha de corte de cada año de 2019 a 2026
  (que la desaparición haya ocurrido y haya sido reportada en ese periodo), agrupadas por sexo
  (sólo mujeres y hombres). 2019 debe ser el primer año que se muestre (parte superior).
  Nota a pie de gráfica: Se consideran sólo las personas cuya desaparición ocurrió y fue
  reportada dentro del periodo.
*/
export const mockMissingComparableData = [
  { label: '2019', values: [3, 87] },
  { label: '2020', values: [10, 72] },
  { label: '2021', values: [15, 61] },
  { label: '2022', values: [8, 54] },
  { label: '2023', values: [7, 60] },
  { label: '2024', values: [6, 36] },
  { label: '2025', values: [4, 40] },
];

// G3: Personas desaparecidas con y sin violencia por año y sexo
/*
  Título: Desapariciones con violencia y sin violencia, por año de desaparición (2019-<año de
  la fecha de corte>)
  Subtítulo: Datos al <fecha de corte>
  Gráfica: Gráfica de barras horizontales apiladas. El dato a graficar es mujeres desaparecidas
  con violencia, hombres desaparecidos con violencia, mujeres desaparecidas sin violencia,
  hombres desaparecidos sin violencia, por año de desaparición de 2019 a 2026
  (2019 debe quedar en la parte superior).
  Nota a pie de gráfica: Se consideran sólo las desapariciones ocurridas a partir de 2019.
*/
export const mockMissingViolenceData = [
  { label: '2019', values: [113, 31, 1039, 438] },
  { label: '2020', values: [105, 25, 790, 302] },
  { label: '2021', values: [109, 26, 821, 173] },
  { label: '2022', values: [74, 25, 888, 280] },
  { label: '2023', values: [75, 28, 731, 327] },
  { label: '2024', values: [53, 23, 621, 195] },
  { label: '2025', values: [54, 20, 457, 136] },
];

// G4: Mujeres desaparecidas por año y rango de edad
/*
  Título: Mujeres desaparecidas, por año de desaparición y rango de edad (2019-<año de la fecha
  de corte>)
  Subtítulo: Datos al <fecha de corte>
  Gráfica: Gráfica de barras horizontales apiladas. El dato a graficar es mujeres desaparecidas
  por año de desaparición (eje Y) y rango de edad (conteo por rango de edad en cada año) de
  2019 a 2026. 2019 debe ser el primer año (primera barra).
  Nota a pie de gráfica: Se consideran sólo las desapariciones de mujeres ocurridas a partir
  de 2019.
*/
export const mockWomenMissingAgeData = [
  { label: '2019', values: [7, 24, 62, 37, 13, 12] },
  { label: '2020', values: [13, 28, 63, 45, 16, 17] },
  { label: '2021', values: [20, 32, 85, 44, 24, 17] },
  { label: '2022', values: [24, 23, 56, 43, 29, 15] },
  { label: '2023', values: [13, 21, 65, 37, 19, 8] },
  { label: '2024', values: [13, 15, 48, 28, 17, 12] },
  { label: '2025', values: [16, 43, 47, 35, 18, 4] },
];

// G5: Hombres desaparecidos por año y rango de edad
/*
  Título: Hombres desaparecidos, por año de desaparición y rango de edad (2019-<año de la fecha
  de corte>)
  Subtítulo: Datos al <fecha de corte>
  Gráfica: Gráfica de barras horizontales apiladas. El dato a graficar es hombres desaparecidos
  por año de desaparición (eje Y) y rango de edad (conteo por rango de edad en cada año) de
  2019 a 2026. 2019 debe ser el primer año (primera barra).
  Nota a pie de gráfica: Se consideran sólo las desapariciones de hombres ocurridas a partir
  de 2019.
*/
export const mockMenMissingAgeData = [
  { label: '2019', values: [8, 107, 526, 547, 249, 110] },
  { label: '2020', values: [16, 95, 419, 387, 224, 121] },
  { label: '2021', values: [14, 106, 463, 345, 218, 104] },
  { label: '2022', values: [20, 105, 481, 397, 260, 124] },
  { label: '2023', values: [16, 93, 432, 376, 244, 129] },
  { label: '2024', values: [10, 106, 338, 291, 160, 114] },
  { label: '2025', values: [32, 147, 262, 198, 111, 88] },
];

// G6: Personas localizadas por condición y tipo de delito (General)
/*
  Título: Personas localizadas, por condición de localización y si fueron o no víctimas de delito
  Subtítulo: Datos del 1 de diciembre de 2018 al <fecha de corte>
  Gráfica: Gráfica de barras horizontales apiladas. Eje Y: personas localizadas con vida y
  personas localizadas sin vida, agrupadas por no víctimas de delito, víctimas de delito
  diverso y víctimas de delito contemplado en la Ley General.
*/
export const mockLocatedConditionCrimeData = [
  { label: 'CON VIDA', values: [14775, 606, 1739] },
  { label: 'SIN VIDA', values: [376, 1214, 1497] },
];

// G7: Porcentaje de localización por año
/*
  Título: Porcentaje de localización por año (2019-2025)
  Subtítulo: Datos del 1 de diciembre de 2018 al <fecha de corte>
  Gráfica: Gráfica de barras verticales (columnas) -como la primera que se muestra en el sitio
  actual. Eje X: año, eje Y: porcentaje de localización (hay que calcularlo: proporción de
  personas desaparecidas, reportadas y localizadas en el año -que coincidan año de reporte,
  año de desaparición y año de localización- respecto del total de personas desaparecidas y
  reportadas en el año -que coincidan año de reporte y año de desaparición-.
  Nota a pie de gráfica: Refleja el porcentaje de personas que fueron localizadas en el año,
  respecto del total de personas cuya desaparición y reporte ocurrieron entre el 1 de enero
  y el 31 de diciembre de ese año.
*/
export const mockPercentageByYearData = [
  { label: '2019', values: [51.21] },
  { label: '2020', values: [54.47] },
  { label: '2021', values: [53.54] },
  { label: '2022', values: [49.49] },
  { label: '2023', values: [50.79] },
  { label: '2024', values: [58.08] },
  { label: '2025', values: [61.68] },
];

// G8: Porcentaje de localización periodo comparable
/*
  Título: Porcentaje de localización del 1 de enero al <día y mes de la fecha de corte> de
  2019 a <año de la fecha de corte>
  Subtítulo: Datos del 1 de diciembre de 2018 al <fecha de corte>
  Gráfica: Gráfica de barras verticales (columnas). Eje X: año, eje Y: porcentaje de localización
  del 1 de enero al <día y mes de la fecha de corte> (hay que calcularlo: proporción de personas
  desaparecidas, reportadas y localizadas en el periodo del 1 de enero al último día del mes
  que se reporta de cada año -que coincidan año y meses de reporte, año y meses de desaparición
  y año y meses de localización- respecto del total de personas desaparecidas y reportadas en
  el año -que coincidan año y meses de reporte y año y meses de desaparición-.
  Nota a pie de gráfica: Refleja el porcentaje de personas que fueron localizadas en el periodo
  del 1 de enero al <día y mes de la fecha de corte> de cada año, respecto del total de personas
  cuya desaparición y reporte ocurrieron ese mismo periodo de cada año.
*/
export const mockPercentageComparableData = [
  { label: '2019', values: [36.79] },
  { label: '2020', values: [35.19] },
  { label: '2021', values: [39.5] },
  { label: '2022', values: [41.7] },
  { label: '2023', values: [31.58] },
  { label: '2024', values: [47.67] },
  { label: '2025', values: [44.64] },
];

// G9: Mujeres localizadas por condición y tipo de delito
/*
  Título: Mujeres localizadas, por condición de localización y si fueron o no víctimas de delito
  Subtítulo: Datos del 1 de diciembre de 2018 al <fecha de corte>
  Gráfica: Gráfica de barras horizontales apiladas. Eje Y: mujeres localizadas con vida y
  mujeres localizadas sin vida, agrupadas por no fueron víctima de delito, víctimas de delito
  diverso y víctimas de delito contemplado en la Ley General.
*/
export const mockWomenLocatedCrimeData = [
  { label: 'CON VIDA', values: [5455, 103, 449] },
  { label: 'SIN VIDA', values: [38, 136, 171] },
];

// G10: Hombres localizados por condición y tipo de delito
/*
  Título: Hombres localizados, por condición de localización y si fueron o no víctimas de delito
  Subtítulo: Datos del 1 de diciembre de 2018 al <fecha de corte>
  Gráfica: Gráfica de barras horizontales apiladas. Eje Y: hombres localizados con vida y
  hombres localizados sin vida, agrupadas por no fueron víctima de delito, víctimas de delito
  diverso y víctimas de delito contemplado en la Ley General.
*/
export const mockMenLocatedCrimeData = [
  { label: 'CON VIDA', values: [9320, 503, 1290] },
  { label: 'SIN VIDA', values: [338, 1078, 1326] },
];

// G11.1: Total desapariciones vs con carpeta de investigación
export const mockInvestigationCIData = [
  { label: 'C.I', values: [13886] },
];

// G11.2: Total desapariciones vs sólo con reporte ante COBUPEJ
export const mockInvestigationReportData = [
  { label: 'Reporte', values: [2209] },
];